import styled from 'styled-components';

import { HIGHLIGHT_COLOR } from '../constants';
import { RewardLockIcon } from '../reward-lock-icon';

import {
  CardContainer as DefaultCardContainer,
  ImageWrapper as DefaultImageWrapper,
  PointTextContainer as DefaultPointTextContainer,
  PointsNeededLockIcon as DefaultPointsNeededLockIcon,
  PointsNeededText as DefaultPointsNeededText,
  RewardText as DefaultRewardText,
  StyledClickableContainer as DefaultStyledClickableContainer,
  StyledProgressMeter as DefaultStyledProgressMeter,
  StyledPointsIcon,
} from './incentive-card.styled.default';

export * from './incentive-card.styled.default';

export const REWARD_CARD_HEIGHT = 7.9375;

export const RewardText = styled(DefaultRewardText)`
  font-size: 1.125rem;
`;

export const ImageWrapper = styled(DefaultImageWrapper)`
  border-radius: 0.25rem;
`;

export const StyledProgressMeter = styled(DefaultStyledProgressMeter)`
  background: ${Styles.color.grey.ten};
  & > div {
    background-color: ${HIGHLIGHT_COLOR};
  }
`;

export const CardContainer = styled(DefaultCardContainer)`
  height: ${`${REWARD_CARD_HEIGHT}rem`};
`;

export const StyledClickableContainer = styled(DefaultStyledClickableContainer)`
  padding: 0.75rem;
`;

export const PointTextContainer = styled(DefaultPointTextContainer)`
  font-weight: ${Styles.fontWeight.heavy};
  color: ${HIGHLIGHT_COLOR};
  ${StyledPointsIcon} {
    path {
      fill: ${HIGHLIGHT_COLOR};
    }
  }
`;

export const PointsNeededText = styled(DefaultPointsNeededText)`
  span {
    color: ${HIGHLIGHT_COLOR};
    font-weight: ${Styles.fontWeight.heavy};
  }
`;

export const StyledLockIcon = styled(RewardLockIcon)`
  & > div > div {
    background-color: ${HIGHLIGHT_COLOR};

    &::before,
    &::after {
      border-color: ${HIGHLIGHT_COLOR};
    }
  }
`;

export const StyledUnLockedRewardPoints = styled.p`
  font-size: 1rem;
  margin-block: 0;
  margin-inline-start: 0.1rem;
  margin-inline-end: 0;
  font-weight: ${Styles.fontWeight.heavy};
`;

export const PointsNeededLockIcon = styled(DefaultPointsNeededLockIcon)`
  display: block;
`;
